<template>
<div>
<TopAppBarDrawer></TopAppBarDrawer>
<main class="main-wrapper flex-grow-1 ">
	<div class="d-flex align-items-center bg-white">
		<div class="t-headline11 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 ">
			<div class="font-m">{{$t('1746')}}</div>
		</div>
	</div>
	<div class="divider"></div>
	<div class="container container--narrow pdt-50 ">
		<div class="t-headline11 font-m mgb-8 ">{{$t('1949')}}</div>
		<div class="t-body1 t-color-bodyGrayA font-r ">{{$t('1950')}}</div>
		<form @submit.prevent="next()" novalidate>
		<div class="mgt-40 mgb-28">
			<label
				class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full h-46 "
				data-mdc-auto-init="MDCTextField" 
				:class="submitState && emailInvalidCheck ? 'mdc-text-field--invalid invalid-icon-data' : 'valid-icon-data'"
					id="emailEl">
				<span class="mdc-notched-outline">
					<span class="mdc-notched-outline__leading" :style="submitState && emailInvalidCheck ? 'border-color:var(--Textfeilderror)!important;':''"></span>
					<span class="mdc-notched-outline__notch" :style="submitState && emailInvalidCheck ? 'border-color:var(--Textfeilderror)!important;':''">
						<span class="mdc-floating-label" id="password-message">{{$t('1951')}}</span>
					</span>
					<span class="mdc-notched-outline__trailing" :style="submitState && emailInvalidCheck ? 'border-color:var(--Textfeilderror)!important;':''"></span>
				</span>
				<input class="mdc-text-field__input" type="text" 
						aria-labelledby="password-message"                        
						v-model="dob"
						v-validate="'required|min:8|max:8'"
						ref="dob"
						id="dob"
						name="dob"
						pattern="[0-9]"
						@keypress="isNumber($event)"
						maxlength="8">
				<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-block" 
				role="button"
				:class="validIcon === 'check' ? 'check_show' : ''"
				>{{validIcon}}</i>
			</label>
			<div class="mdc-text-field-helper-line d-block">
				<div
				:class="submitState && emailInvalidCheck ? 't-color-mainBtn' : ''"
					class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r ">
					{{$t('1952')}}
				</div>
			</div>
		</div>


		<div class="mgt-30 mgb-50">
			<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r">{{$t('1953')}}</span>
			</button>
			<button class="mdc-button bg-white t-color-secondaryBtnText b-radius4"  @click="cancel()" @keypress="cancel()" tabindex="0">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r">{{$t('1954')}}</span>
			</button>
		</div>
		</form>
	</div>
</main>
</div>
</template>

<script>
/**
 * 회원가입 - 아이디 입력(sign up - input email component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import memberApi from "@/api/memberApi.js";
//import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
export default {
	data() {
		return {
			dob: '',
			personalInfo : null,
			emailTextField: null,
			submitState: false,
			validIcon: ''
		}
	},

	mixins: [joinMixin],
	components: {
		TopAppBarDrawer
	},
	computed : {
		// ...mapState('join',{
		//     join : state => state,
		// }),
	   
		// email 유효성 Check 및 아이콘(validation email & set icon)
		emailInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('dob')) {
					returnValue = true
					this.validIcon = 'warning'
				}else {
					returnValue = false
					this.validIcon = 'check'
				}
			}
			this.emailTextField.valid === !returnValue ? '' : this.emailTextField.valid = !returnValue
			return returnValue
		},

	},
	
	created() {
	},
	

	mounted() {
		this.setMaterialUi()
		this.$refs.dob.focus()
		this.fatchData()
	},

	methods: {
		
		fatchData() {
			memberApi.getMemberInfo().then((response)=>{
				this.personalInfo = response.data.data
				this.personalInfo? this.$refs.dob.focus():''
				this.dob = this.personalInfo? this.personalInfo.birth.replace(/-/g, ""):''
			})
		},

		setMaterialUi() {
			this.emailTextField = new MDCTextField(document.querySelector('#emailEl'))
			this.emailTextField.useNativeValidation = false
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})

			this.dob = ''
			this.emailTextField.value = this.dob
			
		},

		next() {
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				if (resultValid) {
					let dateOfBirth = this.dob.toString().split("");
  					let splitdateOfBirth = dateOfBirth.map(x => parseInt(x));
  					let year = `${splitdateOfBirth[0]}${splitdateOfBirth[1]}${splitdateOfBirth[2]}${splitdateOfBirth[3]}`;
  					let month = `${splitdateOfBirth[4]}${splitdateOfBirth[5]}`;
					let date = `${splitdateOfBirth[6]}${splitdateOfBirth[7]}`;
					let params = { birth: year+'-'+month+'-'+date }
  					
					// console.log('=>>>>',params) 
					// return
					// id duplicate check
					memberApi.addDateOfBirth(params).then((response) => {
						let responseData = response.data.data
						if (responseData) {
							this.$router.push({
								name: "MemberDetail",
							})
						} else {
							//this.$snackOpen({contents:this.$t('Todo-비밀번호 변경에 실패하였습니다. 관리자에게 문의 바랍니다.')}).then(() => {})
						}
					}).catch((err) => {
						console.log(err)
					})
					
				} else{
					this.focusFirstInvalidElement()
				}
			})
		},

		isNumber: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode === 46) {
				evt.preventDefault();;
			} else {
				return true;
			}
		},

		cancel() {
			this.$router.push({
				name: "MemberDetail",
			})
		}
	},
}
</script>
<style scoped>
.invalid-icon-data:not(.mdc-text-field--disabled) .mdc-floating-label,
.invalid-icon-data:not(.mdc-text-field--disabled) .mdc-text-field__icon--trailing {
    color: #b00020;
    color: var(--mdc-theme-error, #b00020);
}
.valid-icon-data:not(.mdc-text-field--disabled) .mdc-floating-label,
.valid-icon-data:not(.mdc-text-field--disabled) .mdc-text-field__icon--trailing {
    color: rgba(0, 0, 0, 0.6);
}
.check_show{
	display: block !important;
}
.mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__leading, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__notch, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing{
	border-color: var(--Textfeildactive) !important;
}
</style>